import { CurrencyPipe } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";

export interface ServiceEditorEntry {
  id: string;
  checkboxControlName: string;
  checkboxLabel: string;
  notesControlName: string;
  checkboxTestId?: string;
  notesTestId?: string;
  priceControlName?: string;
  priceTestId?: string;
}

@Component({
  selector: "app-services-editor",
  standalone: true,
  imports: [UiKitModule, ReactiveFormsModule],
  templateUrl: "./services-editor.component.html",
  styleUrl: "./services-editor.component.scss",
  providers: [CurrencyPipe],
})
export class ServicesEditorComponent {
  private currencyPipe = inject(CurrencyPipe);

  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) services: ServiceEditorEntry[] = [];
  @Input() readonly: boolean = false;
  @Input() showPrice: boolean = false;
  @Input() pricePlaceholder: string = "";
  @Input() currency: string = "EUR";
  @Input() locale: string = "de-DE";

  protected processPriceValue(event: Event, controlName?: string) {
    if (!controlName) {
      return;
    }

    const input = event.target as HTMLInputElement;
    const value = this.transformAmount(input.value, this.locale);
    this.form.patchValue({ [controlName]: value });
    input.value = this.formatPriceValue(value);
  }

  protected formatPriceValue(value: unknown) {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    return this.currencyPipe.transform(value as string | number, this.currency, "symbol", "1.2-2", this.locale) ?? "";
  }

  private transformAmount(value: string, locale: string): number {
    const decimalSeparator: string = locale.startsWith("en") ? "." : ",";
    let decimalJoined: string = "00";
    if (value.indexOf(decimalSeparator) > -1) {
      const decimalValue = value.split(decimalSeparator)[1].split("");
      const decimalFiltered = this.removeNaN(decimalValue);
      decimalJoined = decimalFiltered.join("");
    }

    const integerValue = value.split(decimalSeparator)[0].split("");
    const integerFiltered = this.removeNaN(integerValue);
    const integerJoined = integerFiltered.join("");

    return +(integerJoined + "." + decimalJoined);
  }

  private removeNaN(array: string[]) {
    return array.filter((element: any) => !isNaN(element));
  }
}
